
const userprofile = [{"key":"userprofile.title","string":"Vaš profil na rumenih straneh"},{"key":"userprofile.button.update_profile","string":"Posodobi profil"},{"key":"userprofile.no_profile","string":"Niste še dodali profila v rumene strani"}]

export default userprofile



// WEBPACK FOOTER //
// ./src/i18n/sl/adduserprofile/userprofile.js